/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function CalendarIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M15.5 5.5V8h9V5.5c0-.812.625-1.5 1.5-1.5.813 0 1.5.688 1.5 1.5V8H30c2.188 0 4 1.813 4 4v20c0 2.25-1.812 4-4 4H10c-2.25 0-4-1.75-4-4V12c0-2.187 1.75-4 4-4h2.5V5.5c0-.812.625-1.5 1.5-1.5.813 0 1.5.688 1.5 1.5M9 16v16c0 .563.438 1 1 1h20c.5 0 1-.437 1-1V16z"/>}
        </IconWrapper>);
}
